/* PureEatiz collection showcase — size pills update price and the Add to cart variant. */
(function () {
  if (window.__peShowcaseBound) return;
  window.__peShowcaseBound = true;

  document.addEventListener('click', function (event) {
    var pill = event.target instanceof Element ? event.target.closest('.pe-sc-row__size') : null;
    if (!pill) return;
    var row = pill.closest('[data-pe-showcase]');
    if (!row) return;

    row.querySelectorAll('.pe-sc-row__size').forEach(function (other) {
      var active = other === pill;
      other.classList.toggle('is-active', active);
      other.setAttribute('aria-checked', String(active));
    });

    var price = row.querySelector('[data-pe-sc-price]');
    var compare = row.querySelector('[data-pe-sc-compare]');
    var add = row.querySelector('[data-pe-quick-add]');
    var label = row.querySelector('[data-pe-sc-add-label]');
    var available = pill.dataset.available === 'true';

    if (price) price.textContent = pill.dataset.price || '';
    if (compare) compare.textContent = pill.dataset.compare || '';
    if (add) {
      add.dataset.peQuickAdd = pill.dataset.variantId;
      add.disabled = !available;
    }
    if (label) {
      if (!label.dataset.addText) label.dataset.addText = label.textContent.trim();
      label.textContent = available ? label.dataset.addText : 'Sold out';
    }
  });
})();
